<template>
  <nav
    role="navigation"
    class="c-desktop-nav"
  >
    <template v-for="(navItem, index) in navSections">
      <desktop-sub-nav
        :key="`d-${navItem.id}-${index}`"
        :ref="`j-desktop-nav__item_${navItem.id}`"
        :nav-item="navItem"
        :is-mobile="isMobile"
        :my-index="index"
        :search-visible="searchVisible"
        :nav-item-visible="drawingMenus[navItem.id]"
        :nav-visible="navVisible"
        :banner-height="bannerHeight"
        :menu-height="menuHeight"
        class="c-desktop-nav__item"
        :class="{
          'c-desktop-nav__item--no-margin': noMargin(index)
        }"
        @hideSearch="hideSearch"
        @hideDrawingMenu="hideDrawingMenu"
        @showDrawingMenu="showDrawingMenu"
        @update:navVisible="$emit('update:navVisible', $event)"
      />
    </template>
    <div
      ref="activePosition"
      class="c-desktop-nav__active-indicator j-desktop-nav__active-position"
    />
  </nav>
</template>

<script>
import DesktopSubNav from './DesktopSubNav.vue'
import NavMixin from '../NavMixin'

export default {
  name: "DesktopNav",
  components:{
    DesktopSubNav
  },
  mixins: [
    NavMixin
  ],
  computed: {
    subNavVisible() {
      for (let [ key, state ] of Object.entries(this.drawingMenus)) {
        if (state.open) {
          return key
        }
      }
      return null
    }
  },
  watch: {
    subNavVisible() {
      this.positionIndicator()
    }
  },
  mounted(){
    this.positionIndicator()
  },
  methods: {
    noMargin(index) {
      const navSections = this.navSections
      return (
        navSections && navSections.length &&
        (index === navSections.length - 1)
      )
    },
    positionIndicator(){
      this.$nextTick(() => {
        const indicatorElement = this.$refs.activePosition
        const subNavVisible = this.subNavVisible
        if (subNavVisible && indicatorElement) {
          const selectedRefs = this.$refs[`j-desktop-nav__item_${subNavVisible}`]
          if (selectedRefs.length){
            const currentRef = selectedRefs[0]
            const pos = currentRef.$el.getBoundingClientRect()
            try {
              indicatorElement.style.width = `${pos.width}px`
              // adjust for padding
              indicatorElement.style.left = `${currentRef.$el.offsetLeft}px`
            } catch (err) {
              console.warn(err)
            }
          }
        } else if (indicatorElement) {
          indicatorElement.style.width = 0
          indicatorElement.style.left = 0
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
  .c-desktop-nav{
    position: relative;
    &__active-indicator{
      @include themify($themes){
        background-color: themed("background", "dark");
      }
      position: absolute;
      bottom: - rem(39px);
      height: rem(3px);
      width: 0;
      transition: 0.5s;
      z-index: $zindex-global-header;
    }
    &__item{
      display: inline-block;
      margin-right: rem(40px);

      &--no-margin{
        margin-right: 0;
      }
    }

    &__featured{

      &-item{
        list-style: none;
        display: inline;
        position: relative;
        margin-right: rem(30px);
        &-link{
          @include themify($themes) {
            color: themed("primary", "base");
          }
          text-decoration: none;
          position: relative;
          &:after{
            content: "";
            height: 22px;
            width: 100%;
            @include themify($themes) {
              background: linear-gradient(180deg,transparent 70%,themed("accent") 0);
            }
            position: absolute;
            bottom: 0;
            left: 0;
            opacity: 1;
            z-index: -1;
          }
        }
      }

    }
  }
</style>
